import { FC } from 'react';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import { Call } from '#advertDetail/components/contact-list/Call';
import { Whatsapp } from '#advertDetail/components/contact-list/Whatsapp';
import { Telegram } from '#advertDetail/components/contact-list/Telegram';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailContactButtonListCss from '../../assets/model-detail/model-detail-contact-button-list.module.scss';

const ContactList: FC = () => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      contactData,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (contactData.isEmpty) {
    return null;
  }

  return (
    <div className={modelDetailContactButtonListCss.modelDetailContactButtonList}>
      <Call />
      <Whatsapp />
      <Telegram />
    </div>
  );
};

export { ContactList };
